module.exports = __webpack_public_path__ + "static/img/svip_en_content.ee77d45c.png";